<template>
  <HeaderApp />
  <div
    :class="
      'mx-2 mt-14 mb-5 h-full bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 no-print ' +
      ($store.getters['isRtl']
        ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')
    "
  >
    <!-- Header Section -->
    <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">
        {{ $t("add_slider") }}
      </h1>
    </div>

    <!-- Add Slider Form Section -->
    <div
      class="px-6 py-4 border-b border-gray-200 dark:border-gray-700"
      v-if="
        $store.getters['checkUserAccess']({
          id: '39',
          action: 'add',
        })
      "
    >
      <div class="">
        <form @submit.prevent="addSliderItem" enctype="multipart/form-data">
          <div class="grid gap-x-6 mb-6 md:grid-cols-2">
          <BaseInput
            v-model="sl_priority"
            :label="$t('slider_priority')"
            :placeholder="$t('slider_priority')"
            type="number"
            :rules="rules"
            :isError="checkRulesIsError(sl_priority, 'add').isError"
            :errorMsg="checkRulesIsError(sl_priority, 'add').errorMsg"
          />
          <DropdownInput
            v-model="sl_action"
            :label="$t('slider_action')"
            :placeholder="$t('slider_action')"
            :items="[
              { id: 'link', value: 'link' },
              { id: 'phone number', value: 'phone number' },
              { id: 'none', value: 'none' },
            ]"
            :rules="rules_dropdown"
            :isError="
              checkRulesIsError(sl_action, 'add', this.rules_dropdown).isError
            "
            :errorMsg="
              checkRulesIsError(sl_action, 'add', this.rules_dropdown).errorMsg
            "
       
          />

          <BaseInput
            v-model="sl_action_data"
            :label="$t('slider_action_data')"
            :placeholder="$t('slider_action_data')"
            :rules="rules"
            :isError="checkRulesIsError(sl_action_data, 'add').isError"
            :errorMsg="checkRulesIsError(sl_action_data, 'add').errorMsg"
          />

            <FileInput
              :label="$t('item_photo')"
              :placeholder="$t('choose_item_photo')"
              @change="onChange"
              accept="image/*"
            />
          </div>

          <ButtonInput
            type="button"
            @click="addSliderItem"
            :label="$t('add')"
            :isLoading="isBtnLoading"
          />
        </form>
      </div>
    </div>
  </div>

  <div
    :class="
      'mx-2 mt-14 mb-5 h-full bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 no-print ' +
      ($store.getters['isRtl']
        ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')
    "
    v-if="
      $store.getters['checkUserAccess']({
        id: '39',
        action: 'view',
      })
    "
  >
    <!-- Header Section -->
    <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">
        {{ $t("slider_list") }}
      </h1>
    </div>

    <!-- Slider Table Section -->
    <div class="">
      <div class="relative overflow-x-auto mt-4 mb-6">
        <div class="flex items-center justify-between pb-4 mx-5">
          <div class="flex items-center space-x-4">
            <BaseInput
              :modelValue="$store.state.slider.search"
              @update:modelValue="handleSearchInput"
              :placeholder="$t('search')"
              :prefixIcon="'fa-solid fa-search'"
              class="w-40 md:w-full"
            />
          </div>
        </div>
        <EasyDataTable
          v-model:server-options="serverOptions"
          :headers="headers"
          :items="items"
          :server-items-length="serverItemsLength"
          :loading="isLoadingData"
          :alternating="false"
          :buttons-pagination="true"
          :body-text-direction="$store.getters['isRtl'] ? 'right' : 'left'"
          :rows-items="[25, 50, 100, serverItemsLength]"
          rows-per-page="10"
          :hide-footer="isHide"
          :table-class-name="isDark ? 'modern-dark-table mx-6' : 'mx-6'"
        >
          <template #loading>
            <div class="flex items-center justify-center py-8">
              <img
                src="../../assets/loading.webp"
                class="w-16 h-16 animate-pulse"
                alt="Loading..."
              />
            </div>
          </template>
          <template #default="{ column, sortDirection }">
            <div :class="`flex items-center space-x-2 ${$store.getters['isRtl'] ? 'justify-end' : 'justify-start'}`">
              <span class="font-semibold text-gray-700 dark:text-gray-300">{{ column.label }}</span>
              <span v-if="column.sortable" class="text-gray-400">
                <i
                  v-if="sortDirection === 'asc'"
                  class="fa-solid fa-arrow-up text-blue-500"
                ></i>
                <i
                  v-else-if="sortDirection === 'desc'"
                  class="fa-solid fa-arrow-down text-blue-500"
                ></i>
                <i v-else class="fa-solid fa-arrows-up-down text-gray-400"></i>
              </span>
            </div>
          </template>

          <template #item-actions="item">
            <button
              class="mx-1 my-1"
              @click="showModal(item)"
              v-if="
                $store.getters['checkUserAccess']({
                  id: '39',
                  action: 'edit',
                })
              "
            >
              <i
                class="fa-solid fa-pen text-center p-1 w-7 h-7 text-sm bg-blue-200 dark:bg-blue-300 rounded-md text-blue-500 mx-auto"
              >
                {{ item.text }}
              </i>
            </button>
            <button
              class="mx-1 my-1"
              @click="deleteItem(item.sl_id)"
              v-if="
                $store.getters['checkUserAccess']({
                  id: '39',
                  action: 'delete',
                })
              "
            >
              <i
                class="fa-solid fa-trash text-center p-1 w-7 h-7 text-sm bg-red-200 dark:bg-red-300 rounded-md text-red-500 mx-auto"
              ></i>
            </button>
          </template>
          <template #item-sl_image="item">
            <img
              :src="file_url + item.sl_image"
              class="inline-flex items-center justify-center text-white transition-all duration-200 ease-in-out h-16 w-16 rounded-xl"
              alt="xd"
              v-if="item.sl_image"
              @click="openModal(file_url + item.sl_image)"
            />
            <span v-if="item.sl_image == '' || item.sl_image == null">
              <i class="fa-solid fa-image text-primaryColor"></i>
            </span>
          </template>
          <template #item-created_at="item">
            {{ formatDate(item.created_at) }}
          </template>

          <template #empty-message>
            <div class="flex flex-col items-center justify-center py-12 text-gray-500 dark:text-gray-400">
              <i class="fa-solid fa-inbox text-4xl mb-4"></i>
              <span class="text-lg font-medium">{{ $t("no_data_found") }}</span>
            </div>
          </template>

          <template
            #pagination="{
              prevPage,
              nextPage,
              isFirstPage,
              isLastPage,
              currentPaginationNumber,
              maxPaginationNumber,
            }"
          >
            <button :disabled="isFirstPage" @click="goToPage(1)">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-double-right'
                    : ' fa-angle-double-left')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button :disabled="isFirstPage" @click="prevPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-right'
                    : ' fa-angle-left ')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button
              v-for="page in getVisiblePages(
                currentPaginationNumber,
                maxPaginationNumber
              )"
              :key="page"
              @click="goToPage(page)"
              :class="getPageButtonClasses(page, currentPaginationNumber)"
            >
              {{ page }}
            </button>

            <div class="w-5"></div>
            <button :disabled="isLastPage" @click="nextPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-left'
                    : ' fa-angle-right')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button
              :disabled="isLastPage"
              @click="goToPage(maxPaginationNumber)"
            >
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-double-left'
                    : ' fa-angle-double-right')
                "
              ></i>
            </button>
          </template>
        </EasyDataTable>
      </div>
    </div>
  </div>

  <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
  <ResultDialog ref="ResultDialog"></ResultDialog>
  <edit-modal ref="editModal">
    <div class="items-center">
      <form @submit.prevent="editItem">
        <BaseInput
          v-model="current.sl_priority"
          :label="$t('slider_priority')"
          :placeholder="$t('slider_priority')"
          :rules="rules"
          :isError="checkRulesIsError(current.sl_priority, 'edit').isError"
          :errorMsg="checkRulesIsError(current.sl_priority, 'edit').errorMsg"
          type="number"
        />
      
        <DropdownInput
          v-model="current.sl_action"
          :label="$t('slider_action')"
          :placeholder="$t('slider_action')"
          :items="[
            { id: 'link', value: 'link' },
            { id: 'phone number', value: 'phone number' },
            { id: 'none', value: 'none' },
          ]"
          :rules="rules_dropdown"
          :isError="
            checkRulesIsError(current.sl_action, 'edit', this.rules_dropdown).isError
          "
          :errorMsg="
            checkRulesIsError(current.sl_action, 'edit', this.rules_dropdown).errorMsg
          "
       
        />

        <BaseInput
          v-model="current.sl_action_data"
          :label="$t('slider_action_data')"
          :placeholder="$t('slider_action_data')"
          :rules="rules"
          :isError="checkRulesIsError(current.sl_action_data, 'edit').isError"
          :errorMsg="checkRulesIsError(current.sl_action_data, 'edit').errorMsg"
        />

        <div class="my-3">
          <FileInput
            :label="$t('item_photo')"
            :placeholder="$t('choose_item_photo')"
            @change="onChange"
            accept="image/*"
          />
        </div>
        <center>
          <ButtonInput
            type="button"
            @click="editItem"
            :label="$t('edit')"
            :isLoading="isBtnEditLoading"
          />
        </center>
      </form>
    </div> </edit-modal
  ><image-modal ref="imageModal" />
</template>

<script>
import HeaderApp from "../../components/Navbar/header-app.vue";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import ButtonInput from "../../components/Inputs/ButtonInput.vue";
import ConfirmDialogue from "../../components/Modals/ConfirmDialogue.vue";
import ResultDialog from "../../components/Modals/ResultDialog.vue";
import EditModal from "../../components/Modals/EditModal.vue";
import { formatDate } from "../../utils/functions";
import ImageModal from "../../components/Modals/ImageModal2.vue";
import { FILE_URL } from "../../constants/config";
import DropdownInput from "../../components/Inputs/DropdownInput.vue";
import FileInput from "../../components/Inputs/FileInput.vue";
import "../../assets/css/modern-table.css";

export default {
  name: "SliderManager",
  components: {
    HeaderApp,
    BaseInput,
    ButtonInput,
    ConfirmDialogue,
    ResultDialog,
    EditModal,
    DropdownInput,
    FileInput,
    ImageModal,
  },
  data() {
    return {
      rules: [
        (value) => {
          if (value) return true;
          return this.$t("you_must_fill_this_field");
        },
      ],      rules_dropdown: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_choose_an_option");
        },
      ],
      no_rule: [],
      sl_priority: "",
      sl_action: "",
      sl_action_data: "",
      sl_image: "",
      file: "",
      current: {},
      serverItemsLength: 0,
      file_url: FILE_URL,

      serverOptions: {
        page: 1,
        rowsPerPage: 12,
      },
      loading: false,
      items: [],
    };
  },
  mounted() {
    if (
      this.$store.getters["checkUserAccess"]({
        id: "39",
        action: "view",
      })
    ) {
      this.loadFromServer();
    }
  },
  watch: {
    getResultDialog(newValue) {
      if (newValue) {
        this.$refs.ResultDialog.show({
          message: this.$store.state.slider.resultMsg,
          okButton: this.$t("done"),
          isSuccess: this.$store.state.slider.isSuccess,
        });

        this.$store.commit("slider/SET_DELETE_SUCCESS", false);
      }
    },
    serverOptions: {
      handler() {
        this.loadFromServer();
      },
      deep: true,
    },
  },
  computed: {
    getResultDialog() {
      return this.$store.state.slider.isShowResultDialog;
    },
    isDark() {
      return this.$store.state.theme == "dark";
    },
    isLoadingData() {
      return this.$store.state.slider.isLoadingData;
    },
    isBtnLoading() {
      return this.$store.state.slider.isBtnLoading;
    },
    isBtnEditLoading() {
      return this.$store.state.slider.isBtnEditLoading;
    },
    headers() {
      return [
        { text: "#", value: "sl_id", sortable: true },
        {
          text: this.$t("photo"),
          value: "sl_image",
          sortable: true,
        },
        {
          text: this.$t("slider_priority"),
          value: "sl_priority",
          sortable: true,
        },
        { text: this.$t("slider_action"), value: "sl_action", sortable: true },
        {
          text: this.$t("slider_action_data"),
          value: "sl_action_data",
          sortable: true,
        },
        { text: this.$t("created_at"), value: "created_at", sortable: true },
        { text: this.$t("actions"), value: "actions", sortable: false },
      ];
    },
  },
  methods: {
    handleSearchInput(value) {
      this.$store.commit('slider/SET_SEARCH', value);
      this.loadFromServer();
      this.serverOptions.page = 1;
    },
    getVisiblePages(currentPage, totalPages) {
      const numVisibleButtons = 3;
      const pages = [];
      if (currentPage <= Math.floor(numVisibleButtons / 2) + 1) {
        for (let i = 1; i <= Math.min(totalPages, numVisibleButtons); i++) {
          pages.push(i);
        }
      } else {
        const startPage = Math.max(
          1,
          currentPage - Math.floor(numVisibleButtons / 2)
        );
        const endPage = Math.min(totalPages, startPage + numVisibleButtons - 1);
        for (let i = startPage; i <= endPage; i++) {
          pages.push(i);
        }
      }
      return pages;
    },
    getPageButtonClasses(page, currentPage) {
      return {
        "bg-blue-500 text-white": page === currentPage,
        "bg-gray-300 text-gray-700 hover:bg-gray-400": page !== currentPage,
        "p-2 rounded-md mx-1": true,
      };
    },
    openModal(image) {
      this.$refs.imageModal.show(image);
    },
    goToPage(page) {
      this.serverOptions.page = page;
      this.loadFromServer();
    },
    async loadFromServer() {
      this.loading = true;
      const tempObj = { ...this.serverOptions };
      tempObj.search = this.$store.state.slider.search;
      const res = await this.$store.dispatch("slider/getItems", tempObj);
      this.items = res.data.data;
      this.serverItemsLength = res.data.total;
      this.loading = false;
    },
    async addSliderItem() {
      if (this.$store.state.slider.isBtnLoading) return;

      this.isSubmited = true;

      if (
        this.checkRulesIsError(this.sl_priority, "add").isError ||
        this.checkRulesIsError(this.sl_action, "add").isError ||
        this.checkRulesIsError(this.sl_action_data, "add").isError ||
        this.file === null ||
        this.file === ""
      ) {
        return;
      }

      this.$store.state.slider.isBtnLoading = true;

      const res = await this.$store.dispatch("slider/addNewItem", {
        sl_priority: this.sl_priority,
        sl_action: this.sl_action,
        sl_action_data: this.sl_action_data,
        file: this.file,
      });

      if (res.status === 200) {
        this.sl_priority = "";
        this.sl_action = "";
        this.sl_action_data = "";
        this.file = null;
        this.isSubmited = false;
        this.$store.state.slider.isBtnLoading = false;
        this.loadFromServer();
      }
      this.isSubmited = false;
    },
    checkRulesIsError(value, type) {
      var isError = false;
      var errorMsg = "";
      if (type === "add" && !this.isSubmited) {
        return { isError: false, errorMsg: "" };
      }
      if (type === "edit" && !this.isSubmitedEdit) {
        return { isError: false, errorMsg: "" };
      }

      for (const rule of this.rules) {
        if (rule(value) !== true) {
          isError = true;
          errorMsg = rule(value);
          break;
        } else {
          isError = false;
          errorMsg = "";
        }
      }
      return { isError, errorMsg };
    },
    async deleteItem(id) {
      const ok = await this.$refs.confirmDialogue.show({
        message: this.$t("are_you_sure_remove_this_item") + id,
        okButton: this.$t("delete"),
      });
      if (ok) {
        this.$store.commit("slider/REMOVE_ITEM", id);
        this.$store.dispatch("slider/deleteItem", id);
        this.loadFromServer();
      }
    },
    async showModal(item) {
      this.current = { ...item };
      await this.$refs.editModal.show();
    },
    async editItem(e) {
      e.preventDefault();
      this.isSubmitedEdit = true;
      if (
        this.checkRulesIsError(this.current.sl_priority, "edit").isError ||
        this.checkRulesIsError(this.current.sl_action, "edit").isError ||
        this.checkRulesIsError(this.current.sl_action_data, "edit").isError
      ) {
        return;
      }
      this.$store.state.slider.isBtnEditLoading = true;

      const res = await this.$store.dispatch("slider/editItem", {
        sl_id: this.current.sl_id,
        sl_priority: this.current.sl_priority,
        sl_action: this.current.sl_action,
        sl_action_data: this.current.sl_action_data,
        file: this.file,
      });

      this.isSubmitedEdit = false;
      this.file = null;
      this.$store.state.slider.isBtnEditLoading = false;
      if (res.status === 200) {
        this.$refs.editModal.hide();
        this.loadFromServer();
      }
    },
    onChange(files) {
      this.file = files[0] || null;
    },

    handleFileChangeEdit(e) {
      this.fileEdit = e.target.files[0];
    },
    formatDate(date) {
      return formatDate(date);
    },
  },
};
</script>
<style>
input[type="date"]::-webkit-calendar-picker-indicator {
  filter: invert(40%) sepia(96%) saturate(694%) hue-rotate(195deg)
    brightness(85%) contrast(88%);
}

input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}
</style>
